<cipo-dialog-header title="fileFolderPermissions.selectPeople" [closeResult]="[]" />
<mat-dialog-content>
    <div class="p-t-md cipo--height--full">
        <cipo-searchable-listbox [(values)]="listBoxValues" [config]="listBoxConfig()" [options]="listBoxOptions()">
            <mat-button-toggle-group
                [(value)]="allow"
                (change)="loadAvailablePeople($event.value)"
                aria-label="Permissions">
                <mat-button-toggle [value]="true">{{ "fileFolderPermissions.allow" | translate }}</mat-button-toggle>
                <mat-button-toggle [value]="false">{{ "fileFolderPermissions.deny" | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </cipo-searchable-listbox>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="[]">{{ "general.close" | translate }}</button>
    <button mat-raised-button color="primary" (click)="returnPeople()">{{ "general.save" | translate }}</button>
</mat-dialog-actions>
